<template>
    <v-layout column>
        <v-layout justify-center>
            <h1>Crop Work Export</h1>
        </v-layout>
        <v-form v-model="exportForm">
            <v-layout row wrap>
                <v-flex xs12>
                    <v-autocomplete
                        label="Organisation"
                        :value="contractorOrganisationID"
                        :items="availableContractorOrganisations"
                        clearable
                        @input="updateContractorOrganisation"
                    ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                    <v-autocomplete
                        label="Team"
                        :value="teamName"
                        :items="availableTeamNames"
                        clearable
                        @input="updateTeamName"
                    ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6>
                    <date-picker ref="startDate"
                        label="Start Date"
                        :value="startDate"
                        @input="updateStartDate"
                        :rules="[required, beforeEndDate]">
                    </date-picker>
                </v-flex>
                <v-flex xs12 sm6>
                    <date-picker ref="endDate"
                        label="End Date"
                        :value="endDate"
                        @input="updateEndDate"
                        :rules="[required, afterStartDate]">
                    </date-picker>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout>
            <v-btn color="success" :loading="previewLoading" :disabled="!exportForm" @click="preview">Preview</v-btn>
            <v-btn color="success" :loading="exportLoading" :disabled="!exportForm" @click="exportCSV">Export CSV</v-btn>
        </v-layout>
        <v-dialog v-if="error != null" :value="true">
            <v-card>
                <v-toolbar card color="primary subheading" dark height="64">
                    <v-layout row align-start justify-right>
                        <v-flex grow align-self-center>
                            <span class="title">Error</span>
                        </v-flex>
                    </v-layout>
                </v-toolbar>
                <v-card-text>
                    <v-alert type="error" :value="true" style="overflow: auto;">
                        <span>{{ error }}</span>
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="error = null">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <crop-work-export-preview 
            v-if="previewData != null"
            :preview-data="previewData">
        </crop-work-export-preview>
    </v-layout>
</template>

<script>
import DatePicker from '@/components/generic/DatePicker.vue';
import CropWorkExportPreview from '@/components/preceda/CropWorkExportPreview.vue';
import BaseApi from "@/api/baseApi";

export default {
    components: {
        DatePicker,
        CropWorkExportPreview
    },
    props: [
        'contractorOrganisations',
        'teams'
    ],
    data() {
        return {
            exportForm: false,
            contractorOrganisationID: null,
            teamName: null,
            startDate: new Date(),
            endDate: new Date(),
            error: null,
            previewLoading: false,
            previewData: null,
            exportLoading: false
        }
    },

    computed: {
        availableContractorOrganisations(){
            return this.contractorOrganisations.map(x => {
                return {
                    text: x.Name,
                    value: x.ContractorOrganisationID
                };
            }).sort((a, b) => {
                let sortA = (a.text || '').toString().toLocaleLowerCase();
                let sortB = (b.text || '').toString().toLocaleLowerCase();

                if (sortA > sortB) return 1;
                if (sortA < sortB) return -1;

                return 0;
            });
        },
        availableTeamNames(){
            return Object.keys(
                this.teams.reduce((a, v) => {
                    a[v.TeamName] = true;

                    return a;
                }, {})
            ).map(x => {
                return {
                    text: x,
                    value: x
                };
            }).sort((a, b) => {
                let sortA = (a.text || '').toString().toLocaleLowerCase();
                let sortB = (b.text || '').toString().toLocaleLowerCase();

                if (sortA > sortB) return 1;
                if (sortA < sortB) return -1;

                return 0;
            });
        }
    },
    methods: {
        updateContractorOrganisation(v){
            this.contractorOrganisationID = v;
        },
        updateTeamName(v){
            this.teamName = v;
        },
        required(v){
            if(v == null){
                return "Required";
            }

            return false;
        },
        updateStartDate(v){
            this.startDate = v;
            this.$refs.endDate.validate();
        },
        beforeEndDate(v){
            if(v == null || this.endDate == null){
                return false;
            }

            if(this.endDate < v){
                return "Must be before start date";
            }

            return false;
        },
        updateEndDate(v){
            this.endDate = v;
            this.$refs.startDate.validate();
        },
        afterStartDate(v){
            if(v == null || this.startDate == null){
                return false;
            }

            if(v < this.startDate){
                return "Must be after end date";
            }

            return false;
        },
        async preview(){
            this.previewLoading = true;

            try {
                this.previewData = await this.$store.dispatch("PrecedaStore/loadCropWorkPreview", {
                    contractorOrganisationID: this.contractorOrganisationID,
                    teamName: this.teamName,
                    startDate: this.startDate,
                    endDate: this.endDate
                });
            } catch(err){
                this.error = await BaseApi.parseHttpRequestError(err);
            }

            this.previewLoading = false;
        },
        async exportCSV(){
            this.exportLoading = true;

            try {
                await this.$store.dispatch("PrecedaStore/downloadCropWorkExport", {
                    contractorOrganisationID: this.contractorOrganisationID,
                    teamName: this.teamName,
                    startDate: this.startDate,
                    endDate: this.endDate
                });
            } catch(err){
                this.error = await BaseApi.parseHttpRequestError(err);
            }

            this.exportLoading = false;
        }
    },
}
</script>